import { stepDescription } from 'modules/processes/components/ProcessSettings/Steps/StepDescription'

import { useFormProvider } from '../../Providers/form'

export const useStepActionDescription = () => {
  const { currentStep } = useFormProvider()

  const description = stepDescription({
    step: currentStep,
    stepProgressionCondition: currentStep.progressionCondition || '',
    stepProgressionConditionResourceKey: currentStep.progressionConditionResourceKey || '',
  })

  return description
}
